
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientSocialHabitsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientSocialHabits {
   
  regId: string;
  socialHabitsId: string;
  tenantId: string;
  branchId: string;
  duration: number;
  period: string;
  notes: string;
  parameters?: PatientSocialHabitsParameter[];
  links?: any;
  
  socialHabitStatus?: any,
  quantity?: any,
  quantityInPeriod?: any
  //Log
  createdDate?:Date;
  updatedDate?:Date;
  createdBy?:number;
  updatedBy?:number;
  createdIP?:string;
  updatedIP?:string;
}

export abstract class PatientSocialHabitsData {
  abstract list(url: string): Observable<PatientSocialHabits[]>;
  abstract create(url: string, data: PatientSocialHabits): Observable<any>;
  abstract update(url: string, data: PatientSocialHabits): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
